import { thumbnailUrl, type LibraryItemWithMedia } from '../libraryMedia';

export function LibraryMediaView({item}:{item:LibraryItemWithMedia}){
  if(!item.media.length)return null;
  return <div className="library-media">{item.media.map(media=>{
    if(media.media_type==='image')return <img key={media.id} src={thumbnailUrl(media.url)} alt={media.caption||media.file_name} loading="lazy"/>;
    if(media.media_type==='audio')return <audio key={media.id} controls preload="metadata" src={media.url}/>;
    if(media.media_type==='video')return <video key={media.id} controls preload="metadata" playsInline src={media.url}/>;
    return <a key={media.id} className="library-file" href={media.url} target="_blank" rel="noreferrer"><span>Dokument</span><strong>{media.file_name}</strong><b>↗</b></a>;
  })}</div>;
}
